// Protege contra loops infinitos de ResizeObserver sin romper el posicionamiento
// de popups de antd. Usa requestAnimationFrame (no debounce con setTimeout)
// para agrupar callbacks por frame sin retrasar la respuesta.
if (typeof window !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver

  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      let rafId = null
      let lastEntries = []
      const throttledCallback = (entries) => {
        lastEntries = entries
        if (rafId) return
        rafId = requestAnimationFrame(() => {
          rafId = null
          callback(lastEntries)
        })
      }
      super(throttledCallback)
    }
  }

  window.addEventListener('error', (event) => {
    if (
      event.message &&
      (event.message.includes('ResizeObserver loop') ||
        event.message.includes('ResizeObserver loop completed with undelivered notifications'))
    ) {
      event.stopImmediatePropagation()
      event.preventDefault()
      return false
    }
  })

  const originalError = console.error
  console.error = function (...args) {
    if (args.length > 0 && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
      return
    }
    originalError.apply(console, args)
  }
}
